import config from "@/common/config/config";
import cookies from "react-cookies";
// @ts-ignore
import HttpsCtx from "@/common/net/https";

import { Language } from "@/apps/wifiVerify/constants";

export const CT_wifiVerify_pc: number = 10;
export const CT_wifiVerify_m: number = 20;

interface CommonType {
  ct: number;
  language: Language;
}

interface Res<T> {
  success: boolean;
  code: number;
  message: string;
  traceId: string;
  data: T;
}

const httpCtx = HttpsCtx({
  baseUrl: config.API_BFF_URL + "/bff",
  isCheckTid: false,
  // debug: true,
  afterResponse: (resp: any) => {
    if (!resp.success && resp.code === 401) {
      cookies.remove("sid", { path: "/" });
      if (cookies.load("merchantId")) {
        window.location.href = `${config.PARTNER.CCB_OAUTH_URL}?client_id=${config.PARTNER.CCB_CLIENT_ID}&response_type=code&redirect_uri=${config.PARTNER.CCB_REDIRECT_URI}`;
      } else {
        window.location.href = "/login";
      }
    }
  },
});

export type PortalDataReq = CommonType & {
  macAddress: string;
  apMac: string;
  type: 0 | 2; // 0 huawei  2 : WiWide
};

type PortalDataRes = {
  banners: {
    img: string;
    title: string;
  }[];
  permission: {
    huawei: boolean;
    passBy: unknown;
    xingrong: boolean;
    wiWide: boolean;
  };
  storeCode: string;
};

export interface HuaWeiParams {
  apMac?: string;
  uaddress?: string;
  umac?: string;
  ssid?: string;
  nodeIp?: string;
  utm_term?: string;
  utm_source?: string;
}

export interface PortalAuthorizationReq {
  scene: number;
  type: number;
  passBy: unknown;
  verifyCode?: {
    regionCode: string;
    code: string;
    tel: string;
    type: number;
  };
  huaweiParams?: HuaWeiParams;
  xingrongParams?: {
    clientMac: string;
    clientIp: string;
    status: boolean;
    time: string;
    account: {
      openId: string;
      userId: string;
      idType: string;
    };
    wlan: {
      ssid: string;
      password: string;
    };
    site: {
      code: string;
      name: string; //
    };
  };
  wiWide?: {
    umac?: string;
    uaddress?: string;
    storeCode?: string;
    authkey?: string;
  }
}

export interface WechatQRCodeReq {
  type: number;
  params?: HuaWeiParams;
}

interface VerifyCodeBody {
  regionCode: string; //
  tel: string;
  type?: number;
}

const apis = {
  // 该接口用于查询国际地区编码
  getOverseaRegn: ({ ct, language }: { ct?: number; language: Language }) =>
    httpCtx.get("/store/oversea/region", {
      headers: { ct: ct || CT_wifiVerify_pc, language },
    }),
  getPortalData: ({
    ct,
    language,
    macAddress,
    apMac,
  }: PortalDataReq): Promise<Res<PortalDataRes>> =>
    httpCtx.get("/portal/wifi/index", {
      params: {
        macAddress,
        apMac,
      },
      headers: {
        ct,
        language,
      },
    }),
  // Promise.resolve(portalData),

  portalAuthorization: (
    p: PortalAuthorizationReq
  ): Promise<Res<{ jumpUrl: string }>> =>
    httpCtx.post("/portal/wifi/authorization", {
      params: { ...p },
      headers: { ct: CT_wifiVerify_pc },
    }),

  getPortalAuthorization: (p: { umac: string, apMac: string, type: 0 | 2 }): Promise<Res<boolean>> =>
    httpCtx.get("/portal/wifi/authorization/query", {
      params: { ...p },
    }),

  // 太阳码
  getWechatQRCode: (
    p: WechatQRCodeReq,
    hearders: { language: Language }
  ): Promise<Res<string>> =>
    httpCtx.post("/common/wechat/QRCode", {
      params: { ...p },
      headers: { ct: CT_wifiVerify_pc },
    }),

  // 获取手机验证码
  getVerifyCode: (p: VerifyCodeBody): Promise<Res<string>> =>
    httpCtx.post("/passport/verifyCode/send", {
      params: { type: 6, ...p },
      // headers: { ct: CT_wifiVerify_pc },
    }),

  // 生成小程序的URLSchema 非IOS
  getUrlSchema: (p?: WechatQRCodeReq): Promise<Res<string>> => {
    return httpCtx.post("/common/wechat/urlScheme", {
      params: {
        ...p,
      },
      headers: { ct: CT_wifiVerify_pc },
    });
  },

  // 生成小程序的URLSchema IOS
  getUrlLink: (p?: WechatQRCodeReq): Promise<Res<string>> => {
    return httpCtx.post("/common/wechat/urlLink", {
      params: {
        ...p,
      },
      headers: { ct: CT_wifiVerify_pc },
    });
  },
};

export default apis;
